import moment from 'moment';
import ProductType from '../const/productType';

export const createCustomerProductDateSelection = (product, startDate) => {
    const result = [];
    for (let i = 0; i <= 11; i++) {
        const date = moment(startDate).add(i, 'months').startOf('month')
        result.push({
            date: date.format('YYYY-MM-DD'),
            type: product.type === ProductType.StockPrice
                ? ProductType.StockPrice
                : ProductType.FixedPrice,
            productId: product.id,
        });
    }

    return result;
}